import type { RequiredFieldSpec } from './requiredValidation';
import type { InstituteTypeDraftFields } from './instituteTypeRules';
import {
  categoryShowsInstituteType,
  isOtherCorporateInstituteSelected,
} from './instituteTypeRules';
import type { LookupItem } from '../mocks/criminalMasterData';

export function appendInstituteValidationSpecs(
  specs: RequiredFieldSpec[],
  draft: InstituteTypeDraftFields,
  fileCategoryId: string,
  fileCategories: LookupItem[],
  idPrefix: string,
  corporateInstitutes: LookupItem[] = [],
): void {
  if (!categoryShowsInstituteType(fileCategoryId, fileCategories)) return;

  specs.push({
    key: 'instituteType',
    label: 'Institute Type',
    value: draft.instituteType,
    elementId: `${idPrefix}-instituteType`,
  });

  if (draft.instituteType !== 'corporation') return;

  specs.push({
    key: 'corporateInstituteId',
    label: 'Corporate Institute',
    value: draft.corporateInstituteId,
    elementId: `${idPrefix}-corporateInstitute`,
  });

  if (
    isOtherCorporateInstituteSelected(
      draft.corporateInstituteId,
      corporateInstitutes,
      draft.corporateInstituteName,
    )
  ) {
    specs.push({
      key: 'corporateInstituteOther',
      label: 'Other Institute Name',
      value: draft.corporateInstituteOther,
      elementId: `${idPrefix}-corporateOther`,
    });
  }
}
